import React from 'react';
import { StyledBody } from './styles';

const DrawerBody = ({ children }: { children: React.ReactNode }) => (
  <StyledBody>{children}</StyledBody>
);

export { DrawerBody };
